import {WebPubSubClient} from '@azure/web-pubsub-client'
import {Room} from "@/core/api/room.api";
import {Http} from "@/core/service/http.init";
import {roomWaitingEventApi} from "@/core/api/room.waiting.event.api";
import {roomEventApi} from "@/core/api/room.event.api";

// @Deprecated
class GrmWaitingRoomWebPubsubClient {
    #roomId;
    #userId;
    #isReconnected = false;
    #joinedGroups = new Set();
    #webPubsubClient;
    #isClosed = false;
    #closeReason;

    constructor() {}

    async connect({ roomId, userId }) {
        this.#roomId = roomId;
        this.#userId = userId;

        const connection = await this._getConnectionUrl();
        const connectionUrl = connection.connectionUrl;
        const connectionGroups = connection.connectionGroups;
        this.#webPubsubClient = await this._createWebPubsubClient(connectionUrl);
        this._addEventHandler();
        await this.#webPubsubClient.start();
        await this._joinGroups(connectionGroups);
    }

    async disconnect(reason) {
        await this.#webPubsubClient.stop();

        if (!this.#isClosed) {
            this.#isClosed = true;
            this.#closeReason = reason;
        }
    }

    async joinGroup(group) {
        await this._joinGroup(group);
    }

    async leaveGroup(group) {
        await this._leaveGroup(group);
    }

    async _getConnectionUrl() {
        const response = await Http.getHttpInstance({ auth: true })
                                    .post(`/ws/room/${this.#roomId}/waiting/connection`);
        return response.data.data;
    }

    async _createWebPubsubClient(connectionUrl) {
        return new WebPubSubClient(connectionUrl, {
            autoReconnect: true,
            reconnectRetryOptions: {
                mode: "Exponential",
                maxRetries: 600,
                retryDelayInMs: 100,
                maxRetryDelayInMs: 3000
            }
        });
    }

    _addEventHandler() {
        this.#webPubsubClient.on("connected", async (event) => {
            if(this.#isReconnected) {
                await roomEventApi.trigger("room_reconnected");
            }
            this.#isReconnected = false;
        })

        this.#webPubsubClient.on("group-message", async (event) => {
            console.log("Azure web pubsub received group-message : ", event.message.data);
            const message = event.message.data;

            try {
                await roomWaitingEventApi.pushEvent(message);
            } catch (e) {
                console.error(e);
            }
        });

        this.#webPubsubClient.on("rejoin-group-failed", async (event) => {
            const group = event.group;
            console.log(`Azure web pubsub rejoin group ${group} failed : ${event.error}`);
            if(this._isExitedRoom()) {
                return;
            }
            await this._joinGroups(this.#joinedGroups);
        });

        this.#webPubsubClient.on("disconnected", async (event) => {
            if(this._isExitedRoom()) {
                return;
            }

            this.#isReconnected = true;

            const error = event.message;
            if(!!error && error.type === 'system') {
                if (error.message.indexOf('Reason:') > -1) {
                    const closeStatusAsJsonStr = error.message.substring(error.message.indexOf('Reason:') + 7);
                    const closeStatus = JSON.parse(closeStatusAsJsonStr);
                    // await roomEventApi.trigger("room_disconnected", {
                    //     code: closeStatus.code,
                    //     retry: true
                    // });
                    return;
                }

                // await roomEventApi.trigger("room_disconnected", {
                //     code: 1006,
                //     retry: true
                // });
                // return;
            }

            // await roomEventApi.trigger("room_disconnected", {
            //     code: 1001,
            //     retry: true
            // });
        });

        this.#webPubsubClient.on("stopped", async () => {
            if(this._isExitedRoom()) {
                return;
            }

            this.#isReconnected = true;
            // await roomEventApi.trigger("room_disconnected", {
            //     code: 1000,
            //     retry: false
            // });
        });
    }

    _isExitedRoom() {
        return this.#isClosed || Room.isLeaved();
    }

    async _joinGroups(groups) {
        for (const group of groups) {
            await this._joinGroup(group);
        }
    }

    async _joinGroup(group) {
        try {
            await this.#webPubsubClient.joinGroup(group);
            this._addJoinedGroup(group);
        } catch (e) {
            console.error(e);
        }
    }

    _addJoinedGroup(group) {
        if (this.#joinedGroups.has(group)) {
            return;
        }
        this.#joinedGroups.add(group);
    }

    async _leaveGroup(group) {
        try {
            await this.#webPubsubClient.leaveGroup(group);
            this.#joinedGroups.delete(group);
        } catch (e) {
            console.error(e);
        }
    }
}

export const grmWaitingRoomWebPubsubClient = new GrmWaitingRoomWebPubsubClient();